import { WMRateScheduleHeaderLookupLayout, WMItemDpLookupLayout, } from '../../../common/lookups/Layouts/WMLayouts';
import { IDCustomerWithQuickAddLookupLayout, IDCustomerLookupLayout, IDBuyerLookupLayout, IDConsigneeLookupLayout, IDManufacturerLookupLayout, WarantyCodesLookupLayout, IDCodesLookupLayout, IDParticipantLookupLayout } from '../../../common/lookups/Layouts/IdLayouts';
import { EDLookupLayout, EDHazardousLayout } from '../../../common/lookups/Layouts/EDLayouts';
import { ABPopupMessageLayout } from '../../../common/lookups/Layouts/ABLayouts';
import { CAJobLayout } from '../../../common/lookups/Layouts/CALayouts';
import { ACDepartmentLayout } from '../../../common/lookups/Layouts/ACLayouts';
import { FAFundLayout } from '../../../common/lookups/Layouts/FALayouts';
import { IDWarehouseLookupLayout } from '../../../common/lookups/Layouts/IdLayouts';
//import Form from "../../components/quickadd/customer/Form";
import MainTab from '../../../id/codes/customerDataEntry/MainTab';
import { CodeLookupLayout, ContainerLookupLayout, IMFeesLookupLayout, ImItemLookupLayout, IMKitHeaderLookupLayout, IMLocationLookupLayout, IMProductCategoryLookupLayout, ItemDpLookupLayout, ItemGroupLookupLayout, MandateFeesLookupLayout, PriceCodesHeaderLookupLayout } from '../../../common/lookups/Layouts/ImLayouts';
import { IM } from '../../../const/constants';
import { LocationTypes } from '../../../enum/Enum';

const customerLayout = IDCustomerWithQuickAddLookupLayout({
    onCustomItemCreatingComponent: MainTab,
    IdType: "01",
    // onCustomItemCreatingQuickComponent: Form, 
});
const classCodes = CodeLookupLayout({ codeType: '01' });
const subClassCodes = CodeLookupLayout({ codeType: '02' });
const physicalCountCodes = CodeLookupLayout({ codeType: '07' });
const receiptCodes = CodeLookupLayout({ codeType: '30' });
const shipmentCodes = CodeLookupLayout({ codeType: '31' });
const edHazardousLayout = EDHazardousLayout();
const eDLookupLayout = EDLookupLayout({ Dataelementnum: '355', Versionid: '4010' });
const freightClassCodes = CodeLookupLayout({ codeType: '33' });
const holdReasonCodes = CodeLookupLayout({ codeType: '02' });
const popupMessageLayout = ABPopupMessageLayout({ tableName: 'IMLot' });
const runtimeParameter = JSON.stringify([
    { RATESELECTION: 'RATESELECTION' },
    { CLASSCODE: 'CLASSCODE' },
    { SUBCLASSCODE: 'SUBCLASSCODE' },
    { R_PROFILE: 'R_PROFILE' },
    { RWarehouse: 'RWarehouse' }
]);
const ratescheduleCodes = WMRateScheduleHeaderLookupLayout({
    status: 'A', type: "I",
    runtimeParameter
});

const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "RECORD",
                "tableName": "IMLOT",
                "localizedField": "Keysequence",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Status",
                "tableName": "IMLOT",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Size1",
                "tableName": "IMLOT",
                "label": "Size1",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "LotCode",
                "tableName": "IMLOT",
                "label": "Lot Code",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Description1",
                "tableName": "IMLOT",
                "label": "Description 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "ITEMCODE",
                "tableName": "IMLOT",
                "label": "Item",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Description2",
                "tableName": "IMLOT",
                "label": "Description - 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },


        ]
    },
    {
        "groupId": 4,
        "fields": [
            {
                "name": "ClassCode",
                "tableName": "IMLOT",
                "label": "Class Code",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SubClassCode",
                "tableName": "IMLOT",
                "label": "Sub Class Code",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CreationDateTime",
                "tableName": "IMLOT",
                "label": "Creation Date Time",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CreationUserId",
                "tableName": "IMLOT",
                "label": "Creation User Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LastUpdateDateTime",
                "tableName": "IMLOT",
                "label": "Last Update Date Time",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LastUpdateUserId",
                "tableName": "IMLOT",
                "label": "Last Update User Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CompanyId",
                "tableName": "IMLOT",
                "label": "Company Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Module",
                "tableName": "IMLOT",
                "label": "Module",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RecordType",
                "tableName": "IMLOT",
                "label": "Record Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Description2",
                "tableName": "IMLOT",
                "label": "Description2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "Comment",
                "tableName": "IMLOT",
                "label": "Comment",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LotSizeCode",
                "tableName": "IMLOT",
                "label": "Lot Size Code",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LotProjectionCode",
                "tableName": "IMLOT",
                "label": "Lot Projection Code",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LotUnitUomFlag",
                "tableName": "IMLOT",
                "label": "Lot Unit Uom Flag",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LotUomDefault",
                "tableName": "IMLOT",
                "label": "Lot Uom Default",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LotUnitsPerItemUnit",
                "tableName": "IMLOT",
                "label": "Lot Units Per Item Unit",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RoyaltyFlag",
                "tableName": "IMLOT",
                "label": "Royalty Flag",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RoyaltyUnitCost",
                "tableName": "IMLOT",
                "label": "Royalty Unit Cost",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RoyaltyUnitPrice",
                "tableName": "IMLOT",
                "label": "Royalty Unit Price",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RoyaltyAddToPriceFlag",
                "tableName": "IMLOT",
                "label": "Royalty Add To Price Flag",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "StageFlag",
                "tableName": "IMLOT",
                "label": "Stage Flag",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ReorderInventoryMinimumQty",
                "tableName": "IMLOT",
                "label": "Reorder Inventory Minimum Qty",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ReorderInventoryMaximumQty",
                "tableName": "IMLOT",
                "label": "Reorder Inventory Maximum Qty",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ReorderQuantityEoqCalculated",
                "tableName": "IMLOT",
                "label": "Reorder Quantity Eoq Calculated",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ReorderQuantityOrderMultiple",
                "tableName": "IMLOT",
                "label": "Reorder Quantity Order Multiple",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ReorderSafetyQuantity",
                "tableName": "IMLOT",
                "label": "Reorder Safety Quantity",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ReorderLeadTime",
                "tableName": "IMLOT",
                "label": "Reorder Lead Time",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CostBasisMethodFlag",
                "tableName": "IMLOT",
                "label": "Cost Basis Method Flag",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "AverageCost",
                "tableName": "IMLOT",
                "label": "Average Cost",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "StandardCost",
                "tableName": "IMLOT",
                "label": "Standard Cost",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RPriceTable",
                "tableName": "IMLOT",
                "label": "RPrice Table",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CorePrice",
                "tableName": "IMLOT",
                "label": "Core Price",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "MaximumPriceLevelForDiscount",
                "tableName": "IMLOT",
                "label": "Maximum Price Level For Discount",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TradeDiscountOnSpecialPriceAr",
                "tableName": "IMLOT",
                "label": "Trade Discount On Special Price Ar",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "EarlyPayDiscountFlag",
                "tableName": "IMLOT",
                "label": "Early Pay Discount Flag",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CostAllocationFactor",
                "tableName": "IMLOT",
                "label": "Cost Allocation Factor",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DateIntroduced",
                "tableName": "IMLOT",
                "label": "Date Introduced",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ReorderQuantityEntered",
                "tableName": "IMLOT",
                "label": "Reorder Quantity Entered",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DateAvailable",
                "tableName": "IMLOT",
                "label": "Date Available",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ReorderMethodFlag",
                "tableName": "IMLOT",
                "label": "Reorder Method Flag",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DateExpiration",
                "tableName": "IMLOT",
                "label": "Date Expiration",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ReorderMinimumDaysOnHand",
                "tableName": "IMLOT",
                "label": "Reorder Minimum Days On Hand",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode1",
                "tableName": "IMLOT",
                "label": "User Defined Code1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ReorderMaximumDaysOnHand",
                "tableName": "IMLOT",
                "label": "Reorder Maximum Days On Hand",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode2",
                "tableName": "IMLOT",
                "label": "User Defined Code2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode3",
                "tableName": "IMLOT",
                "label": "User Defined Code3",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "UserDefinedCode4",
                "tableName": "IMLOT",
                "label": "User Defined Code4",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode6",
                "tableName": "IMLOT",
                "label": "User Defined Code6",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode7",
                "tableName": "IMLOT",
                "label": "User Defined Code7",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "VendorItemCode",
                "tableName": "IMLOT",
                "label": "Vendor Item Code",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode8",
                "tableName": "IMLOT",
                "label": "User Defined Code8",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "UserDefinedCode9",
                "tableName": "IMLOT",
                "label": "User Defined Code9",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "OemManufacturerCode",
                "tableName": "IMLOT",
                "label": "Oem Manufacturer Code",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode10",
                "tableName": "IMLOT",
                "label": "User Defined Code10",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference1",
                "tableName": "IMLOT",
                "label": "User Defined Reference1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference2",
                "tableName": "IMLOT",
                "label": "User Defined Reference2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference3",
                "tableName": "IMLOT",
                "label": "User Defined Reference3",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference4",
                "tableName": "IMLOT",
                "label": "User Defined Reference4",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference5",
                "tableName": "IMLOT",
                "label": "User Defined Reference5",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference6",
                "tableName": "IMLOT",
                "label": "User Defined Reference6",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference7",
                "tableName": "IMLOT",
                "label": "User Defined Reference7",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference8",
                "tableName": "IMLOT",
                "label": "User Defined Reference8",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference9",
                "tableName": "IMLOT",
                "label": "User Defined Reference9",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference10",
                "tableName": "IMLOT",
                "label": "User Defined Reference10",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate1",
                "tableName": "IMLOT",
                "label": "User Defined Date1",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate2",
                "tableName": "IMLOT",
                "label": "User Defined Date2",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate3",
                "tableName": "IMLOT",
                "label": "User Defined Date3",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate4",
                "tableName": "IMLOT",
                "label": "User Defined Date4",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate5",
                "tableName": "IMLOT",
                "label": "User Defined Date5",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate6",
                "tableName": "IMLOT",
                "label": "User Defined Date6",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate7",
                "tableName": "IMLOT",
                "label": "User Defined Date7",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate8",
                "tableName": "IMLOT",
                "label": "User Defined Date8",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate9",
                "tableName": "IMLOT",
                "label": "User Defined Date9",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate10",
                "tableName": "IMLOT",
                "label": "User Defined Date10",
                "type": "date",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity1",
                "tableName": "IMLOT",
                "label": "User Defined Quantity1",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity2",
                "tableName": "IMLOT",
                "label": "User Defined Quantity2",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity3",
                "tableName": "IMLOT",
                "label": "User Defined Quantity3",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity4",
                "tableName": "IMLOT",
                "label": "User Defined Quantity4",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity5",
                "tableName": "IMLOT",
                "label": "User Defined Quantity5",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity6",
                "tableName": "IMLOT",
                "label": "User Defined Quantity6",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity7",
                "tableName": "IMLOT",
                "label": "User Defined Quantity7",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity8",
                "tableName": "IMLOT",
                "label": "User Defined Quantity8",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity9",
                "tableName": "IMLOT",
                "label": "User Defined Quantity9",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity10",
                "tableName": "IMLOT",
                "label": "User Defined Quantity10",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "InventoryUnitUom",
                "tableName": "IMLOT",
                "label": "Inventory Unit Uom",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PiecesPerUnitUom",
                "tableName": "IMLOT",
                "label": "Pieces Per Unit Uom",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PiecesPerUnitQuantity",
                "tableName": "IMLOT",
                "label": "Pieces Per Unit Quantity",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UnitsPerPackageUom",
                "tableName": "IMLOT",
                "label": "Units Per Package Uom",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UnitsPerPackageQuantity",
                "tableName": "IMLOT",
                "label": "Units Per Package Quantity",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PackagesPerShippingUnitUom",
                "tableName": "IMLOT",
                "label": "Packages Per Shipping Unit Uom",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PackagesPerShippingUnitQty",
                "tableName": "IMLOT",
                "label": "Packages Per Shipping Unit Qty",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UnitVolumeUom",
                "tableName": "IMLOT",
                "label": "Unit Volume Uom",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UnitVolumeQuantity",
                "tableName": "IMLOT",
                "label": "Unit Volume Quantity",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UnitAreaUom",
                "tableName": "IMLOT",
                "label": "Unit Area Uom",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UnitAreaQuantity",
                "tableName": "IMLOT",
                "label": "Unit Area Quantity",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UnitValueUom",
                "tableName": "IMLOT",
                "label": "Unit Value Uom",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "NetWeightUom",
                "tableName": "IMLOT",
                "label": "Net Weight Uom",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "NetWeightQuantity",
                "tableName": "IMLOT",
                "label": "Net Weight Quantity",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "GrossWeightUom",
                "tableName": "IMLOT",
                "label": "Gross Weight Uom",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UnitValueQuantity",
                "tableName": "IMLOT",
                "label": "Unit Value Quantity",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "GrossWeightQuantity",
                "tableName": "IMLOT",
                "label": "Gross Weight Quantity",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "OnHand",
                "tableName": "IMLOT",
                "label": "On Hand",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "InOrdered",
                "tableName": "IMLOT",
                "label": "In Ordered",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "OutOrdered",
                "tableName": "IMLOT",
                "label": "Out Ordered",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "InReceiving",
                "tableName": "IMLOT",
                "label": "In Receiving",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "OutShipped",
                "tableName": "IMLOT",
                "label": "Out Shipped",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "InBackOrder",
                "tableName": "IMLOT",
                "label": "In Back Order",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "OutBackOrder",
                "tableName": "IMLOT",
                "label": "Out Back Order",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "InUnavailable",
                "tableName": "IMLOT",
                "label": "In Unavailable",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "OutUnavailable",
                "tableName": "IMLOT",
                "label": "Out Unavailable",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "InFuture",
                "tableName": "IMLOT",
                "label": "In Future",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "OutFuture",
                "tableName": "IMLOT",
                "label": "Out Future",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Available",
                "tableName": "IMLOT",
                "label": "Available",
                "type": "text",
                "filterType":"rangeFrom",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "NetAvailable",
                "tableName": "IMLOT",
                "label": "Net Available",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "StorageBillingStartDate",
                "tableName": "IMLOT",
                "label": "Storage Billing Start Date",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "StorageBillingEndDate",
                "tableName": "IMLOT",
                "label": "Storage Billing End Date",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RRateSchedule",
                "tableName": "IMLOT",
                "label": "RRate Schedule",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PopupMessage",
                "tableName": "IMLOT",
                "label": "Popup Message",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LastCost",
                "tableName": "IMLOT",
                "label": "Last Cost",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "RBuyer",
                "tableName": "IMLOT",
                "label": "RBuyer",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Size2",
                "tableName": "IMLOT",
                "label": "Size2",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "StorageBilledDateLast",
                "tableName": "IMLOT",
                "label": "Storage Billed Date Last",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "StorageBilledDateNext",
                "tableName": "IMLOT",
                "label": "Storage Billed Date Next",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PriceSource",
                "tableName": "IMLOT",
                "label": "Price Source",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PriceMethod",
                "tableName": "IMLOT",
                "label": "Price Method",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CalcMethod",
                "tableName": "IMLOT",
                "label": "Calc Method",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PriceLevelA",
                "tableName": "IMLOT",
                "label": "Price Level A",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PriceLevelB",
                "tableName": "IMLOT",
                "label": "Price Level B",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PriceLevelC",
                "tableName": "IMLOT",
                "label": "Price Level C",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PriceLevelD",
                "tableName": "IMLOT",
                "label": "Price Level D",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PriceLevelE",
                "tableName": "IMLOT",
                "label": "Price Level E",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RGlDepartment",
                "tableName": "IMLOT",
                "label": "RGl Department",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RGlFund",
                "tableName": "IMLOT",
                "label": "RGl Fund",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RCaJob",
                "tableName": "IMLOT",
                "label": "RCa Job",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PriceBasis",
                "tableName": "IMLOT",
                "label": "Price Basis",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RFees",
                "tableName": "IMLOT",
                "label": "RFees",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "RfReceiptValidation",
                "tableName": "IMLOT",
                "label": "Rf Receipt Validation",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RfShipmentValidation",
                "tableName": "IMLOT",
                "label": "Rf Shipment Validation",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "InTransactionNumber",
                "tableName": "IMLOT",
                "label": "In Transaction Number",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DateLastReceipt",
                "tableName": "IMLOT",
                "label": "Date Last Receipt",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RParticipant",
                "tableName": "IMLOT",
                "label": "RParticipant",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CommissionBasis",
                "tableName": "IMLOT",
                "label": "Commission Basis",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CommissionAmount",
                "tableName": "IMLOT",
                "label": "Commission Amount",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RoundingMethod",
                "tableName": "IMLOT",
                "label": "Rounding Method",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RoundingFactor",
                "tableName": "IMLOT",
                "label": "Rounding Factor",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "AlternateStandardCost",
                "tableName": "IMLOT",
                "label": "Alternate Standard Cost",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "AlternateAverageCost",
                "tableName": "IMLOT",
                "label": "Alternate Average Cost",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "AlternateLastCost",
                "tableName": "IMLOT",
                "label": "Alternate Last Cost",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PrevStorageBilledDateLast",
                "tableName": "IMLOT",
                "label": "Prev Storage Billed Date Last",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PrevStorageBilledDateNext",
                "tableName": "IMLOT",
                "label": "Prev Storage Billed Date Next",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RecurringStorage",
                "tableName": "IMLOT",
                "label": "Recurring Storage",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ProgressiveCurrentRate",
                "tableName": "IMLOT",
                "label": "Progressive Current Rate",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ProgressiveLastRate",
                "tableName": "IMLOT",
                "label": "Progressive Last Rate",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ProgressivePreviousLastRate",
                "tableName": "IMLOT",
                "label": "Progressive Previous Last Rate",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ProgressiveBillingCount",
                "tableName": "IMLOT",
                "label": "Progressive Billing Count",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RLotSource",
                "tableName": "IMLOT",
                "label": "RLot Source",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },


            {
                "name": "",
                "tableName": "IMLOT",
                "label": "",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Record",
                "tableName": "IMLOT",
                "label": "Record",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ItemCode",
                "tableName": "IMLOT",
                "label": "Item Code",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RProfile",
                "tableName": "IMLOT",
                "label": "RProfile",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RWarehouse",
                "tableName": "IMLOT",
                "label": "RWarehouse",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
        ]
    }
];

const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "Record",
                "localizedField": "RECORD",
                "tableName": "IMLOT",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "RProfile",
                "localizedField": "RPROFILE",
                "tableName": "IMLOT",
                "label": "Profile",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": ItemDpLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "RWarehouse",
                "localizedField": "RWAREHOUSE",
                "tableName": "IMLOT",
                "label": "Warehouse",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IDWarehouseLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "RItem",
                "tableName": "IMLOT",
                "localizedField": "RITEM",
                "label": "Item",
                "type": "lookup",
                "layout": ImItemLookupLayout({ itemType: null, moduleName: IM, runtimeParameter }),
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "LotCode",
                "tableName": "IMLOT",
                "localizedField": "LOTCODE",
                "label": "Lot",
                "type": "text",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Description1",
                "tableName": "IMLOT",
                "localizedField": "DESCRIPTION_1",
                "label": "Description - 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Description2",
                "tableName": "IMLOT",
                "localizedField": "DESCRIPTION_2",
                "label": "Description - 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },


        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "RProductCategory",
                "tableName": "IMLOT",
                "localizedField": "RPRODUCTCATEGORY",
                "label": "Product Category",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IMProductCategoryLookupLayout(),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Status",
                "tableName": "IMLOT",
                "localizedField": "STATUS",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ClassCode",
                "tableName": "IMLOT",
                "localizedField": "CLASSCODE",
                "label": "Class",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": classCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SubClassCode",
                "tableName": "IMLOT",
                "localizedField": "SUBCLASSCODE",
                "label": "Sub Class",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": subClassCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DateIntroduced",
                "tableName": "IMLOT",
                "localizedField": "DATEINTRODUCED",
                "label": "Introduced Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DateAvailable",
                "tableName": "IMLOT",
                "localizedField": "DATEAVAILABLE",
                "label": "Available Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DateExpiration",
                "tableName": "IMLOT",
                "localizedField": "DATEEXPIRATION",
                "label": "Expiration Dt",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
]

const UOMLayout = [
    {
        "groupId": 1,
        "label": "Inventory Factors",
        "fields": [
            {
                "name": "InventoryUnitNotUsed",
                "localizedField": "INVENTORYUNITNOTUSED",
                "tableName": "IMLOT",
                "label": "Inventory",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "PiecesPerUnitQuantity",
                "localizedField": "PIECESPERUNITQUANTITY",
                "tableName": "IMLOT",
                "label": "Pieces/Unit",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UnitsPerPackageQuantity",
                "localizedField": "UNITSPERPACKAGEQUANTITY",
                "tableName": "IMLOT",
                "label": "Units/Pkg",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PackagesPerShippingUnitQty",
                "localizedField": "PACKAGESPERSHIPPINGUNITQTY",
                "tableName": "IMLOT",
                "label": "Pkg/Ship",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UnitVolumeQuantity",
                "localizedField": "UNITVOLUMEQUANTITY",
                "tableName": "IMLOT",
                "label": "Unit Volume",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UnitAreaQuantity",
                "localizedField": "UNITAREAQUANTITY",
                "tableName": "IMLOT",
                "label": "Unit Area",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UnitValueQuantity",
                "localizedField": "UNITVALUEQUANTITY",
                "tableName": "IMLOT",
                "label": "Unit Value",
                "type": "number",
                "format": "$ #,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "NetWeightQuantity",
                "localizedField": "NETWEIGHTQUANTITY",
                "tableName": "IMLOT",
                "label": "Unit Net Wt",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "GrossMinusNet",
                "localizedField": "GROSSMINUSNET",
                "tableName": "IMLOT",
                "label": "Unit Tare Wt",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "GrossWeightQuantity",
                "localizedField": "GROSSWEIGHTQUANTITY",
                "tableName": "IMLOT",
                "label": "Unit Gross Wt",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "UOM",
        "fields": [
            {
                "name": "InventoryUnitUom",
                "localizedField": "INVENTORYUNITUOM",
                "tableName": "IMLOT",
                "label": "Inventory Unit",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PiecesPerUnitUom",
                "localizedField": "PIECESPERUNITUOM",
                "tableName": "IMLOT",
                "label": "Pieces/Unit",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UnitsPerPackageUom",
                "localizedField": "UNITSPERPACKAGEUOM",
                "tableName": "IMLOT",
                "label": "Units/Pkg",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PackagesPerShippingUnitUom",
                "localizedField": "PACKAGESPERSHIPPINGUNITUOM",
                "tableName": "IMLOT",
                "label": "Pkg/Ship",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UnitVolumeUom",
                "localizedField": "UNITVOLUMEUOM",
                "tableName": "IMLOT",
                "label": "Unit Volume",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UnitAreaUom",
                "localizedField": "UNITAREAUOM",
                "tableName": "IMLOT",
                "label": "Unit Area",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UnitValueUom",
                "localizedField": "UNITVALUEUOM",
                "tableName": "IMLOT",
                "label": "Unit Value",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "NetWeightUom",
                "localizedField": "NETWEIGHTUOM",
                "tableName": "IMLOT",
                "label": "Unit Net Wt",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "Miscellaneous",
        "fields": [
            {
                "name": "PhysicalCountCode",
                "localizedField": "PHYSICALCOUNTCODE",
                "tableName": "IMLOT",
                "label": "Count Cycle",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": physicalCountCodes,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ROemManufactureId",
                "localizedField": "ROEMMANUFACTUREID",
                "tableName": "IMLOT",
                "label": "Manuf ID",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IDManufacturerLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "OemManufacturerCode",
                "localizedField": "OEMMANUFACTURERCODE",
                "tableName": "IMLOT",
                "label": "OEM Code",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RLocation",
                "localizedField": "RLOCATION",
                "tableName": "IMLOT",
                "label": "Location",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IMLocationLookupLayout({ moduleType: IM, locationType: LocationTypes.StorageLocation, RWarehouse: null }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ItemsUpcCode",
                "localizedField": "ITEMSUPCCODE",
                "tableName": "IMLOT",
                "label": "Alternate SKU",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "OversellPercentage",
                "localizedField": "OVERSELLPERCENTAGE",
                "tableName": "IMLOT",
                "label": "Oversell Percentage","format": "#,###0.00",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "SaleMaxQuantity",
                "tableName": "IMLOT",
                "label": "Sale Max Qty",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "SALEMAXQUANTITY"
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Brokerage/Consign. Payments",
        "fields": [
            {
                "name": "RParticipant",
                "localizedField": "RPARTICIPANT",
                "tableName": "IMLOT",
                "label": "Participant", "lookupDisplayMode": "grid",
                "type": "lookup",
                "layout": IDParticipantLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "CommissionBasis",
                "localizedField": "COMMISSIONBASIS",
                "tableName": "IMLOT",
                "label": "Comm. Basis",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "CommissionAmount",
                "localizedField": "COMMISSIONAMOUNT",
                "tableName": "IMLOT",
                "label": "Comm. Amount",
                "type": "number", "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 5,
        "label": "Comment",
        "fields": [
                        {
                "name": "Comment",
                "localizedField": "COMMENT",
                "tableName": "IMLOT",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
]
const StatusLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "OnHand",
                "localizedField": "ONHAND",
                "tableName": "IMLOT",
                "label": "On Hand",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "InReceiving",
                "localizedField": "INRECEIVING",
                "tableName": "IMLOT",
                "label": "In Receiving",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "OutShipped",
                "localizedField": "OUTSHIPPED",
                "tableName": "IMLOT",
                "label": "In Shipping",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "OutUnavailable",
                "localizedField": "OUTUNAVAILABLE",
                "tableName": "IMLOT",
                "label": "Unavailable",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "Available",
                "localizedField": "AVAILABLE",
                "tableName": "IMLOT",
                "label": "Available",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "InOrdered",
                "localizedField": "INORDERED",
                "tableName": "IMLOT",
                "label": "Pending Rec",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "OutOrdered",
                "localizedField": "OUTORDERED",
                "tableName": "IMLOT",
                "label": "Pending Ship",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "NetAvailable",
                "localizedField": "NETAVAILABLE",
                "tableName": "IMLOT",
                "label": "Net Available",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "InFuture",
                "localizedField": "INFUTURE",
                "tableName": "IMLOT",
                "label": "Future Rec",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }, {
                "name": "OutFuture",
                "localizedField": "OUTFUTURE",
                "tableName": "IMLOT",
                "label": "Future Ship",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
        ]
    }
]
const ReOrderLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "ReorderMethodFlag",
                "localizedField": "REORDERMETHODFLAG",
                "tableName": "IMLOT",
                "label": "Method",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "ReorderMaximumDaysOnHand",
                "localizedField": "REORDERMAXIMUMDAYSONHAND",
                "tableName": "IMLOT",
                "label": "Maximum Days",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "ReorderLeadTime",
                "localizedField": "REORDERLEADTIME",
                "tableName": "IMLOT",
                "label": "Lead Days",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 4,
        "fields": [
            {
                "name": "ReorderInventoryMinimumQty",
                "localizedField": "REORDERINVENTORYMINIMUMQTY",
                "tableName": "IMLOT",
                "label": "Minimum Quantity",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "ReorderQuantityEntered",
                "localizedField": "REORDERQUANTITYENTERED",
                "tableName": "IMLOT",
                "label": "Entered Qty",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "ReorderSafetyQuantity",
                "localizedField": "REORDERSAFETYQUANTITY",
                "tableName": "IMLOT",
                "label": "Safety Qty",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 7,
        "fields": [
            {
                "name": "ReorderInventoryMaximumQty",
                "localizedField": "REORDERINVENTORYMAXIMUMQTY",
                "tableName": "IMLOT",
                "label": "Maximum Quantity",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "ReorderQuantityEoqCalculated",
                "localizedField": "REORDERQUANTITYEOQCALCULATED",
                "tableName": "IMLOT",
                "label": "Calculated Qty",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 9,
        "fields": [
            {
                "name": "ReorderMinimumDaysOnHand",
                "localizedField": "REORDERMINIMUMDAYSONHAND",
                "tableName": "IMLOT",
                "label": "Minimum Days",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "ReorderQuantityOrderMultiple",
                "localizedField": "REORDERQUANTITYORDERMULTIPLE",
                "tableName": "IMLOT",
                "label": "Order Multiple",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
]
const CodesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedCode1",
                "localizedField": "USERDEFINEDCODE_1",
                "tableName": "IMLOT",
                "label": "Code 1",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '11' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode2",
                "localizedField": "USERDEFINEDCODE_2",
                "tableName": "IMLOT",
                "label": "Code 2",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '12' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode3",
                "localizedField": "USERDEFINEDCODE_3",
                "tableName": "IMLOT",
                "label": "Code 3",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '13' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode4",
                "localizedField": "USERDEFINEDCODE_4",
                "tableName": "IMLOT",
                "label": "Code 4",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '14' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode5",
                "localizedField": "USERDEFINEDCODE_5",
                "tableName": "IMLOT",
                "label": "Code 5",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '15' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode6",
                "localizedField": "USERDEFINEDCODE_6",
                "tableName": "IMLOT",
                "label": "Code 6",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '16' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode7",
                "localizedField": "USERDEFINEDCODE_7",
                "tableName": "IMLOT",
                "label": "Code 7",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '17' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode8",
                "localizedField": "USERDEFINEDCODE_8",
                "tableName": "IMLOT",
                "label": "Code 8",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '18' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode9",
                "localizedField": "USERDEFINEDCODE_9",
                "tableName": "IMLOT",
                "label": "Code 9",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '19' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode10",
                "localizedField": "USERDEFINEDCODE_10",
                "tableName": "IMLOT",
                "label": "Code 10",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: '20' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedDate1",
                "localizedField": "USERDEFINEDDATE_1",
                "tableName": "IMLOT",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate2",
                "localizedField": "USERDEFINEDDATE_2",
                "tableName": "IMLOT",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate3",
                "localizedField": "USERDEFINEDDATE_3",
                "tableName": "IMLOT",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate4",
                "localizedField": "USERDEFINEDDATE_4",
                "tableName": "IMLOT",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate5",
                "localizedField": "USERDEFINEDDATE_5",
                "tableName": "IMLOT",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate6",
                "localizedField": "USERDEFINEDDATE_6",
                "tableName": "IMLOT",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate7",
                "localizedField": "USERDEFINEDDATE_7",
                "tableName": "IMLOT",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate8",
                "localizedField": "USERDEFINEDDATE_8",
                "tableName": "IMLOT",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate9",
                "localizedField": "USERDEFINEDDATE_9",
                "tableName": "IMLOT",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedDate10",
                "localizedField": "USERDEFINEDDATE_10",
                "tableName": "IMLOT",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedQuantity1",
                "localizedField": "USERDEFINEDQUANTITY_1",
                "tableName": "IMLOT",
                "label": "Quantity 1",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity2",
                "localizedField": "USERDEFINEDQUANTITY_2",
                "tableName": "IMLOT",
                "label": "Quantity 2",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity3",
                "localizedField": "USERDEFINEDQUANTITY_3",
                "tableName": "IMLOT",
                "label": "Quantity 3",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity4",
                "localizedField": "USERDEFINEDQUANTITY_4",
                "tableName": "IMLOT",
                "label": "Quantity 4",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity5",
                "localizedField": "USERDEFINEDQUANTITY_5",
                "tableName": "IMLOT",
                "label": "Quantity 5",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity6",
                "localizedField": "USERDEFINEDQUANTITY_6",
                "tableName": "IMLOT",
                "label": "Quantity 6",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity7",
                "localizedField": "USERDEFINEDQUANTITY_7",
                "tableName": "IMLOT",
                "label": "Quantity 7",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity8",
                "localizedField": "USERDEFINEDQUANTITY_8",
                "tableName": "IMLOT",
                "label": "Quantity 8",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity9",
                "localizedField": "USERDEFINEDQUANTITY_9",
                "tableName": "IMLOT",
                "label": "Quantity 9",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedQuantity10",
                "localizedField": "USERDEFINEDQUANTITY_10",
                "tableName": "IMLOT",
                "label": "Quantity 10",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    }
]
const RefrencesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedReference1",
                "localizedField": "USERDEFINEDREFERENCE_1",
                "tableName": "IMLOT",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference2",
                "localizedField": "USERDEFINEDREFERENCE_2",
                "tableName": "IMLOT",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference3",
                "localizedField": "USERDEFINEDREFERENCE_3",
                "tableName": "IMLOT",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference4",
                "localizedField": "USERDEFINEDREFERENCE_4",
                "tableName": "IMLOT",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference5",
                "localizedField": "USERDEFINEDREFERENCE_5",
                "tableName": "IMLOT",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference6",
                "localizedField": "USERDEFINEDREFERENCE_6",
                "tableName": "IMLOT",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference7",
                "localizedField": "USERDEFINEDREFERENCE_7",
                "tableName": "IMLOT",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference8",
                "localizedField": "USERDEFINEDREFERENCE_8",
                "tableName": "IMLOT",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference9",
                "localizedField": "USERDEFINEDREFERENCE_9",
                "tableName": "IMLOT",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedReference10",
                "localizedField": "USERDEFINEDREFERENCE_10",
                "tableName": "IMLOT",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]

const KitLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "BomExplosionFlag",
                "tableName": "IMLOT",
                "label": "IM Kit Flag",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "BOMEXPLOSIONFLAG",
            },
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "OmKitFlag",
                "tableName": "IMLOT",
                "label": "OM Kit Flag",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "OMKITFLAG",
            },
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "PmKitFlag",
                "tableName": "IMLOT",
                "label": "PM Kit Flag",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "PMKITFLAG",
            },
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RItemKittCode",
                "localizedField": "R_ITEMKITTCODE",
                "tableName": "IMLOT",
                "label": "Kit Code",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IMKitHeaderLookupLayout({ RIdentity: null, ModuleName: IM }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "Description",
                "tableName": "IMLOT",
                "label": "Descripton",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "DESCRIPTION",
            },
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RWarehouse",
                "localizedField": "R_WAREHOUSE",
                "tableName": "IMLOT",
                "label": "Warehouse",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": IDWarehouseLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RAssociateItem",
                "tableName": "IMLOT",
                "label": "Item",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": ImItemLookupLayout({ itemType: null, moduleName: IM, runtimeParameter }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "RASSOCIATEITEM",
            },
        ]
    },
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "AssociateDesc",
                "tableName": "IMLOT",
                "label": "Associate Description",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "ASSOCIATEDESC",
            },
        ]
    },
]
const CostPriceLayout = [
    {
        "groupId": 1,
        "label": "Pricing",
        "fields": [
            {
                "name": "PriceSource",
                "tableName": "IMLOT",
                "label": "Price Source",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "PRICESOURCE",
            },
            {
                "name": "PriceMethod",
                "tableName": "IMLOT",
                "label": "Price Method",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "PRICEMETHOD",
            },

            {
                "name": "PriceBasis",
                "tableName": "IMLOT",
                "label": "Price Basis",
                "type": "number",
                "format": "$#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "PRICEBASIS",
            },
            {
                "name": "CalcMethod",
                "tableName": "IMLOT",
                "label": "Calc Method",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "CALCMETHOD",
            },
            {
                "name": "PriceLevelA",
                "tableName": "IMLOT",
                "label": "Price Level A",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "PRICELEVELA",
            },
            {
                "name": "PriceLevelB",
                "tableName": "IMLOT",
                "label": "Price Level B",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "PRICELEVELB",
            },
            {
                "name": "PriceLevelC",
                "tableName": "IMLOT",
                "label": "Price Level C",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "PRICELEVELC",
            },
            {
                "name": "PriceLevelD",
                "tableName": "IMLOT",
                "label": "Price Level D",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "PRICELEVELD",
            },
            {
                "name": "PriceLevelE",
                "tableName": "IMLOT",
                "label": "Price Level E",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "PRICELEVELE",
            },
            {
                "name": "RPriceTable",
                "tableName": "IMLOT",
                "label": "Price Table",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": PriceCodesHeaderLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "R_PRICETABLE",
            },

        ]
    },
    {
        "groupId": 2,
        "label": "Costing",
        "fields": [
            {
                "name": "CostBasisMethodFlag",
                "tableName": "IMLOT",
                "label": "Cost Basis Method Flag",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "COSTBASISMETHODFLAG",
            },
            {
                "name": "StandardCost",
                "tableName": "IMLOT",
                "label": "Standard Cost",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "STANDARDCOST",
            },
            {
                "name": "AverageCost",
                "tableName": "IMLOT",
                "label": "Average Cost",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "AVERAGECOST",
            },
            {
                "name": "LastCost",
                "tableName": "IMLOT",
                "label": "Last Cost",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "LASTCOST",
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Price Rounding",
        "fields": [
            {
                "name": "RoundingMethod",
                "tableName": "IMLOT",
                "label": "Rounding Method",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "ROUNDINGMETHOD",
            },
            {
                "name": "RoundingFactor",
                "tableName": "IMLOT",
                "label": "Rounding Factor",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "ROUNDINGFACTOR",
            },

        ]
    },
    {
        "groupId": 3,
        "label": "Rack Quantities",
        "fields": [
            {
                "name": "RFees",
                "tableName": "IMLOT",
                "label": "Fees",
                "type": "lookup",
                "layout": IMFeesLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "localizedField": "RFEES",
            }

        ]
    }
]
const MiscLayout = [
    {
        "groupId": 1,
        "label": "Commissions Pay Groups",
        "fields": [
            {
                "name": "MinimumSalesQuantity",
                "tableName": "IMLOT",
                "label": "Min Sales Qty",
                "type": "number", "format": "#,###",
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "MINIMUMSALESQUANTITY"
            },
            {
                "name": "SaleIncrementQuantity",
                "tableName": "IMLOT",
                "label": "Sales Multiple",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "SALEINCREMENTQUANTITY"
            },
            {
                "name": "ItemPayGroup",
                "tableName": "IMLOT",
                "label": "Item",
                "type": "lookup",
                "layout": IDCodesLookupLayout({ codeType: '04' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "ITEMPAYGROUP"
            }
        ]
    },

    {
        "groupId": 6,
        "label": "Serial Numbers",
        "fields": [
            {
                "name": "ShipSelection",
                "tableName": "IMLOT",
                "label": "Use Serial #",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "SHIPSELECTION"
            },
            {
                "name": "AutomaticallyUpdateQuantity",
                "tableName": "IMLOT",
                "label": "Qty Auto Update",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "AUTOMATICALLYUPDATEQUANTITY"
            },
            {
                "name": "UpdateUomWeight",
                "tableName": "IMLOT",
                "label": "Update UOM",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "UPDATEUOMWEIGHT"
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Item Grouping",
        "fields": [
            {
                "name": "RItemGroup",
                "tableName": "IMLOT",
                "label": "Item Group",
                "type": "lookup",
                "layout": ItemGroupLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "R_ITEMGROUP"
            },
            {
                "name": "ItemSubGroup",
                "tableName": "IMLOT",
                "label": "Item Sub Group",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: 'B7' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "ITEMSUBGROUP"
            },
            {
                "name": "ItemMember",
                "tableName": "IMLOT",
                "label": "Item Member",
                "type": "lookup", "lookupDisplayMode": "grid",
                "layout": CodeLookupLayout({ codeType: 'B8' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "ITEMMEMBER"
            }
        ]
    },


    {
        "groupId": 7,
        "label": "Labels",
        "fields": [
            {
                "name": "Reference1",
                "tableName": "IMLOT",
                "label": "Item Ref 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "REFERENCE1"
            },
            {
                "name": "Reference2",
                "tableName": "IMLOT",
                "label": "Item Ref 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "REFERENCE2"
            },
            {
                "name": "Reference3",
                "tableName": "IMLOT",
                "label": "Item Ref 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "REFERENCE3"
            },
            {
                "name": "Reference4",
                "tableName": "IMLOT",
                "label": "Item Ref 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "REFERENCE4"
            },
            {
                "name": "Reference5",
                "tableName": "IMLOT",
                "label": "Item Ref 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "REFERENCE5"
            },
            {
                "name": "OversellPercentage",
                "tableName": "IMLOT",
                "label": "Oversell %",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "OVERSELLPERCENTAGE"
            },
            {
                "name": "SaleMaxQuantity",
                "tableName": "IMLOT",
                "label": "Sale Max Qty",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "SALEMAXQUANTITY"
            }
        ]
    },
    {
        "groupId": 3,
        "label": "WEB Settings",
        "fields": [
            {
                "name": "WebAccessibility",
                "tableName": "IMLOT",
                "label": "Accessibility",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "WEBACCESSIBILITY"
            }
        ]
    },
    {
        "groupId": 5,
        "label": "Containers",
        "fields": [
            {
                "name": "RContainerCode",
                "tableName": "IMLOT",
                "label": "Container",
                "type": "lookup",
                "layout": ContainerLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false
                , "localizedField": "RCONTAINERCODE"
            }
        ]
    }
];

export {
    SearchLayout,
    PrimaryLayout,
    UOMLayout,
    StatusLayout,
    CodesLayout,
    RefrencesLayout,
    KitLayout,
    ReOrderLayout,
    CostPriceLayout,
    MiscLayout
}